import { memo, useMemo } from 'react'

/** Bars shown at most: a message's 64 levels are drawn as the loudest of each few. */
export const WAVEFORM_BARS = 40
/** Bars for a voice message sent without levels (its recorder couldn't measure them). */
const FLAT = Array.from({ length: WAVEFORM_BARS }, () => 18)

function bars(levels: readonly number[] | null): readonly number[] {
  if (!levels?.length) return FLAT
  if (levels.length <= WAVEFORM_BARS) return levels
  return Array.from({ length: WAVEFORM_BARS }, (_, bar) => {
    const start = Math.floor((bar * levels.length) / WAVEFORM_BARS)
    const end = Math.max(start + 1, Math.floor(((bar + 1) * levels.length) / WAVEFORM_BARS))
    return Math.max(...levels.slice(start, end))
  })
}

/** A voice message's levels as bars, the part already played in the accent colour. */
export const Waveform = memo(function Waveform({ levels, progress }: { levels: readonly number[] | null; progress: number }) {
  const shown = useMemo(() => bars(levels), [levels])
  const played = Math.round(Math.max(0, Math.min(1, progress)) * shown.length)
  return (
    <span className="waveform" aria-hidden="true">
      {shown.map((level, index) => (
        <span key={index} className={index < played ? 'is-played' : undefined} style={{ height: `${Math.max(12, Math.min(100, level))}%` }} />
      ))}
    </span>
  )
})
